// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'fire-solid';

export const Component = () => (
  <path d='M21.63 16.666c0 1.963-.91 3.736-2.73 5.364-1.868 1.676-3.88 2.49-6.082 2.49h-.24c1.485-.047 2.683-.67 3.688-1.772.958-1.101 1.437-2.442 1.437-4.118 0-.623-.239-1.293-.766-2.012-.527-.67-1.054-1.293-1.628-1.82-.575-.526-1.054-1.197-1.39-2.107-.335-.91-.382-1.868-.143-2.873-1.868 0-3.449.814-4.79 2.442-1.388 1.628-2.059 3.449-2.059 5.412 0 1.58.432 2.97 1.341 4.262.91 1.293 1.916 2.107 3.113 2.443-2.347-.383-4.358-1.629-5.939-3.688C3.814 18.63 3 16.33 3 13.745c0-3.784 1.437-7.04 4.359-9.722C10.28 1.34 13.393 0 16.745 0c-.575 1.437-.814 2.634-.718 3.544.095.91.43 1.915 1.053 3.017.623 1.101 1.246 2.06 1.916 2.873.67.862 1.293 1.964 1.82 3.257.526 1.294.814 2.635.814 3.975Z' />
);

export const viewBox = '0 0 25 25';
